/**
 * Single source of truth for "does the platform prefer reduced motion" -- consumed by
 * app.module.ts (BrowserAnimationsModule.withConfig({ disableAnimations }), since not all Material/CDK animations
 * run through plain CSS).
 */
export const prefersReducedMotion = (): boolean =>
  typeof window !== 'undefined' && typeof window.matchMedia === 'function' && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
